<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="menuItem mt-3">
    <router-link to="/vues">
      {{ $t("vuesFavorites.title") }}
    </router-link>
  </div>
  <div v-if="model.length > 0">
    <ul class="layout-menu">
      <li v-for="(item, i) in model" :key="item.label || i" role="none">
        <router-link
          v-ripple
          v-tooltip="item.label"
          :aria-label="item.label"
          :to="item.to"
          class="p-ripple flex"
          exact
          role="menuitem"
          @click="onMenuItemClick({ originalEvent: $event, item: item })"
        >
          <span
            class="overflow-hidden text-overflow-ellipsis white-space-nowrap"
            >{{ item.label }}</span
          >
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useUserViewStore } from "@/stores/userView.js";

/**
 * A component that displays a menu of favorite advanced searches.
 * It fetches both personal and global favorite searches and provides navigation links.
 */
export default {
  name: "FavoriteViewMenu",
  emits: ["menuitem-click"],
  computed: {
    ...mapState(useUserViewStore, {
      model: "favoriteViews",
    }),
  },
  methods: {
    ...mapActions(useUserViewStore, ["fetchFavoriteViews"]),
    /**
     * Emits an event when a menu item is clicked.
     * @param {Object} event - The click event object.
     */
    onMenuItemClick(event) {
      this.$emit("menuitem-click", event);
    },
  },
  async mounted() {
    await this.fetchFavoriteViews();
  },
};
</script>
<style scoped>
.layout-menu li a {
  padding: 0 !important;
}
.menuItem {
  text-transform: uppercase;
  color: var(--surface-900);
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}
</style>
